import lodash from 'lodash';

export default function combineStyles(...arr: any): { [key: string]: React.CSSProperties } {
  return lodash.merge({}, ...lodash.flatten(arr));
}
